.block {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 0 auto;
}

.badge {
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, -50%);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px 12px;
  border-radius: 24px;
  border: 0.5px solid rgba(255, 255, 255, 0.00);
  background: #AE66F6;
  box-shadow: 1px -3px 16px 0 rgba(255, 255, 255, 0.60) inset;
  max-width: calc(100% - 40px);
  min-width: calc(100% - 40px);

  @at-root html[lang='en'] & {
    min-width: max-content;
  }
}

.badgeIcon {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
}

.badgeText {
  color: #fffbf2;
  text-align: center;
  font-family: ui-rounded, "SF Pro Rounded", Nunito, "SF Pro Text", -apple-system, BlinkMacSystemFont, "Roboto",
    sans-serif;
  font-size: clamp(11px, 3.6vw, 14px);
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.056px;
  text-transform: uppercase;
}

.card {
  position: relative;
  width: 100%;
  padding: 8px;
  padding-top: 32px;
  border-radius: 32px;
  background: #f2ede1;
  overflow: hidden;
}

.title {
  color: var(--Text-Main-TextPrimary, #221E1A);
  text-align: center;
  font-family: ui-rounded, "SF Pro Rounded", Nunito, "SF Pro Text", -apple-system, BlinkMacSystemFont, "Roboto",
    sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 29px;
}

.illustration {
  position: relative;
  width: 100%;
  padding-top: 12px;
  margin: 0 auto;
}

.decor {
  position: absolute;
  z-index: 0;
  opacity: 0.5;
  pointer-events: none;
}

.decorFlower {
  top: 87px;
  left: 10px;
  width: 48px;
}

.decorCross {
  top: 174px;
  right: 0;
  width: 48px;
}


.avatarCard {
  max-width: 76px;
  max-height: 76px;
  position: absolute;
  bottom: 0;
  left: 25;
  transform: translateY(60%) rotate(-9.695deg);
  border-radius: 22px;
  border: 1.5px solid #0D92F0;
  background: #EBEBED;
  box-shadow: 2px 4px 0 0 #0D92F0;
  overflow: hidden;

  img {
    width: 78px;
  }
}
